import { render, staticRenderFns } from "./ServicePackageProgramView.vue?vue&type=template&id=a3b24706"
import script from "./ServicePackageProgramView.vue?vue&type=script&lang=js"
export * from "./ServicePackageProgramView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports